import { connect } from 'react-redux';
import CalendarPage from './CalendarPage';

const mapStateToProps = ({ settings }) => ({
  ...settings,
});

const CalendarPageConnected = connect(
  mapStateToProps,
  null,
)(CalendarPage);

export default CalendarPageConnected;
